let Vue = require('vue').default;
var snotify = require('vue-snotify');
import VueRecaptcha from 'vue-recaptcha';

import {axios, handleAjaxError} from './common';

module.exports = function(form) {   
    Vue.use(snotify.default);
    var empty = Object.assign({}, form);

    return new Vue({
        el: '#contactsForm',
        data: function () {
            return {
                form: Object.assign({}, empty),
                errors: null,
            };
        },
        components: { 'vue-recaptcha': VueRecaptcha },
        methods: {
            onSubmit: function () {
                this.save();
            },
            save: function () {
                var vm = this;
                this.errors = null;
                axios.post(window.location, this.form)
                    .then(function (response) { 
                        if (vm.$refs.recaptcha)
                            vm.$refs.recaptcha.reset();
                        vm.$snotify.confirm('Message Sent', "Thank you!", { 
                            position: snotify.SnotifyPosition.centerCenter,
                            timeout: 0,
                            backdrop: 0.5,
                            buttons: [
                                {text: 'Got It!', action: (toast) => {
                                    Object.assign(vm.form, empty);
                                    
                                    vm.$snotify.remove(toast.id);
                                }},
                            ]
                        });                        
                    }).catch(handleAjaxError.bind(vm));
            },
            onVerify: function (token) {
                this.form.token = token
                console.log('Verify: ' + token);
            },
            // onExpired: function () {
            // console.log('Expired')
            // },
            // resetRecaptcha () {
            // this.$refs.recaptcha.reset() // Direct call reset method
            // }
        }
    });
};